'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'timer';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e29e';
var svgPathData = 'M256 0l-16 0 0 128 32 0 0-95.4c116.2 8.2 208 105.1 208 223.4 0 123.7-100.3 224-224 224S32 379.7 32 256c0-61.9 25.1-117.8 65.6-158.4L75 75C28.7 121.3 0 185.3 0 256 0 397.4 114.6 512 256 512S512 397.4 512 256 397.4 0 256 0zM171.3 148.7l-11.3-11.3-22.6 22.6 11.3 11.3 96 96 11.3 11.3 22.6-22.6-11.3-11.3-96-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTimer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;